'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'cherries';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M288 32l8.9-13.3L273.8 3.3 272 31s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l0 .2-.1 .9c-.1 .8-.2 2.1-.4 3.9c-.4 3.5-1 8.6-2.1 15.2c-2.2 13.2-6 32-12.8 54.2C244.2 146.5 221.8 199 182 249.2c-15.2-9.4-46.7-25.2-86-25.2c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-21.5 0-40.7 4.7-56.1 10.6c27.8-42.9 44.9-85.3 55.4-119.9c6.4-21.2 10.4-39.5 12.9-53.4l.4 .3c13.3 10.9 31.2 26.8 49.5 47.1c31.1 34.4 62.6 80.2 76.3 133.9c-13.2-6.7-31.7-14.1-53.6-17.2c11.7 10.6 22.1 24.2 29.8 41.3c1.7 .7 3.3 1.4 4.8 2.2c7 3.3 12.5 6.5 16.1 8.9c1.8 1.2 3.1 2.1 3.9 2.7c.4 .3 .6 .5 .8 .6c0 0 0 0 0 0L448 297l19.9-15.9c0 0 0 0 0 0c.1-.1 .4-.3 .8-.6c.8-.6 2.1-1.5 3.9-2.7c3.6-2.3 9.1-5.6 16.1-8.9c14.1-6.6 33.3-12.9 55.1-13c0 0 .1 0 .1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C590 273.9 608 291.3 608 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-14.6 0-42.6-4-71.1-15.9c-7 9.2-14.8 17.4-23 24.8C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-37.4 0-67.6 14.3-83.6 23.7C447 181.1 409 126.2 373.9 87.3c-19.7-21.7-38.8-38.8-53-50.4c-7.1-5.8-13-10.3-17.2-13.4c-2.1-1.5-3.7-2.7-4.9-3.5c-.6-.4-1-.7-1.3-.9l-.4-.3-.1-.1c0 0 0 0 0 0s0 0 0 0L288 32zm-.2 224c0 0 .1 0 .1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C334 273.9 352 291.3 352 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-19.1 0-61.1-6.9-97.2-29.2C60.5 429.5 32 395 32 336c0-44.7 18-62.2 32.1-70.4c8.1-4.7 16.4-7.2 23-8.5c3.2-.6 5.8-.9 7.4-1.1c.8-.1 1.4-.1 1.6-.1c0 0 .1 0 .1 0c21.9 0 41.1 6.3 55.1 13c7 3.3 12.5 6.5 16.1 8.9c1.8 1.2 3.1 2.1 3.9 2.7c.4 .3 .6 .5 .8 .6c0 0 0 0 0 0L192 297l19.9-15.9c0 0 0 0 0 0c.1-.1 .4-.3 .8-.6c.8-.6 2.1-1.5 3.9-2.7c3.6-2.3 9.1-5.6 16.1-8.9c14.1-6.6 33.3-12.9 55.1-13z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;